<div class="d-flex align-items-center w-100"
    style="padding-top: 80px;padding-bottom: 36px;height: 42px;background-color: #ffffff; border-bottom: 1px solid black">
  <ng-container *ngFor="let category of categories; let i = index; let last = last">
    <span class="d-flex justify-content-center align-items-center w-100"
        style="gap: .5em">
        <button #categoryButton
                class="btn d-flex justify-content-center align-items-center button-new-search"
                style="width: 100%; gap: .5em;"
                type="button"
                (mouseenter)="onButtonHover(i, true)"
                (mouseleave)="onButtonHover(i, false)"
                (click)="openFormSearch(category.label)">
                      <img #icon src="{{category.icon}}"
                          [ngStyle]="{'width': getSize(i)}"
                          alt="">
                      <p class="mb-0" style="font-family: 'Poppins', serif; font-size: 16px;font-weight: 500;">{{i === 5 && activeComingSoonIndex ? 'Proximamente' : category.label}}</p>
        </button>
    </span>
  </ng-container>
</div>
